module.exports = __webpack_public_path__ + "static/logos-tiles-tish-224e34a6adf4df30cba66c38af5ddff6.svg";